<!-- eslint-disable vue/valid-v-model -->
<template>
  <div class="feedback-container">
    <div class="select-tree">
      <el-tree
        :data="serviceTypeList"
        :props="defaultProps"
        default-expand-all
        node-key="id"
        highlight-current
        :current-node-key="currentNodeKey"
        ref="tree"
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
          <span style="color: #333;"> {{ data.num }}</span>
        </span>
      </el-tree>
    </div>
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-input
            v-model="searchInfo.code"
            placeholder="输入硬件编码"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-input
            v-model="searchInfo.frameNum"
            placeholder="输入车架号"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-input
            v-model="searchInfo.iccid"
            placeholder="输入iccid"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>

        <div class="right">
          <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="showForm(0, 'add')"
            v-hasPermi="['硬件管理', '新增']"
            >新增</el-button
          >
          <!-- <el-button
            type="primary"
            style="margin-left: 16px"
            @click="showDialog"
            v-hasPermi="['硬件管理', '批量选择']"
            >导入</el-button
          >
          <el-button
            type="danger"
            style="margin-left: 16px"
            :disabled="multipleSelection.length === 0"
            @click="deleteSelection()"
            v-hasPermi="['硬件管理', '删除']"
            >删除</el-button
          > -->
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="serviceTypeName" label="服务类型" align="center">
        </el-table-column>
        <el-table-column prop="code" label="硬件编号" align="center">
        </el-table-column>
        <el-table-column prop="frameNum" label="车架号" align="center">
        </el-table-column>
        <el-table-column prop="iccid" label="ICCID" align="center">
        </el-table-column>

        <el-table-column
          prop="orderExpireTime"
          label="订单有效期"
          align="center"
        >
        </el-table-column>

        <el-table-column prop="versionCode" label="软件版本编号" align="center">
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <span
              style="color: rgb(255, 153, 0);"
              v-if="scope.row.status === 1"
            >
              在线
            </span>
            <span
              style="color: rgb(67, 202, 154);"
              v-if="scope.row.status === 2"
            >
              离线
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="操作" width="170" align="center">
          <template slot-scope="scope">
            <div class="edit">
              <span
                class="btn read"
                v-hasPermi="['硬件管理', '详情']"
                @click="showForm(scope.row.id, 'detail')"
                >查看</span
              >
              <span
                class="btn read"
                v-hasPermi="['硬件管理', '编辑']"
                @click="showForm(scope.row.id, 'edit')"
                >编辑</span
              >
              <span
                class="btn read"
                v-if="!scope.row.frameNum"
                @click="deleteClick(scope.row.id)"
                v-hasPermi="['硬件管理', '删除']"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.page"
          :page-size="table.pageSize"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
    <ExcelImport
      ref="formInfoRef"
      :type="formType"
      :id="id"
      :visible="importDialogVisible"
      @visible-change="modalImportVisibleChange"
      @success="refresh()"
    ></ExcelImport>
    <FormInfo
      ref="formInfoRef"
      :type="formType"
      :id="id"
      :visible="formDialogVisible"
      @visible-change="modalVisibleChange"
      @success="refresh()"
    ></FormInfo>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import { getServiceTypeCountList } from '@/api/serviceType';
import { getHardwareList, deleteHardware } from '@/api/hardware';
import FormInfo from './add';
import ExcelImport from './excel-import.vue';

export default {
  components: {
    FormInfo,
    ExcelImport,
  },
  data() {
    return {
      id: null,
      formType: '',
      formDialogVisible: false,
      importDialogVisible: false,

      serviceTypeList: [{ name: '全部', id: 0, children: [] }],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      currentNodeKey: 0, //当前选中的点
      loading: false,
      table: {
        data: [],
        height: 100,
        page: 1,
        pageSize: 50,
        total: 0,
      },
      multipleSelection: [],
      searchInfo: {
        code: '',
        iccid: '',
        serviceTypeId: '',
      },
    };
  },
  created() {
    // this.getSortData()
    this.getServiceTypeData();
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170;
      window.onresize = () => {
        this.table.height =
          window.innerHeight - this.$refs.table.offsetTop - 170;
      };
    });
  },
  methods: {
    showDialog() {
      this.importDialogVisible = true;
    },

    modalVisibleChange(val) {
      this.formDialogVisible = val;
    },
    modalImportVisibleChange(val) {
      this.importDialogVisible = val;
    },
    // 弹窗
    showForm(id, type) {
      this.formDialogVisible = true;
      this.formType = type;
      this.id = id;
    },
    handleNodeClick(e) {
      this.searchInfo.serviceTypeId = e.id === 0 ? '' : e.id;
      this.table.page = 1;
      this.getData();
      this.currentNodeKey = this.searchInfo.serviceTypeId;
    },
    //获取数据
    getServiceTypeData() {
      getServiceTypeCountList().then((da) => {
        this.serviceTypeList[0].children = da.data;
        this.$nextTick(() => {
          this.$refs['tree'].setCurrentKey(this.currentNodeKey); // [全部]高亮
        });
      });
    },
    getData() {
      const params = {
        ...this.searchInfo,
        page: this.table.page,
        pageSize: this.table.pageSize,
      };
      getHardwareList(params).then((da) => {
        this.table.data = da.data.content;
        this.table.total = da.data.total;
      });
    },
    toggleSelection() {
      // this.table.data.forEach(row => {
      if (this.multipleSelection.length === this.table.total) {
        return;
      } else {
        this.$refs.multipleTable.toggleAllSelection();
        this.multipleSelection = this.table;
      }
      // });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search() {
      this.table.page = 1;
      this.getData();
    },
    currentChange() {
      this.getData();
    },
    handleSizeChange(e) {
      this.table.page = 1;
      this.table.pageSize = e;
      this.getData();
    },
    deleteClick(id) {
      MessageBox.confirm('此操作将删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteHardware(id).then((res) => {
          if (res.code == 0) {
            this.$message.success('删除成功!');
            this.refresh();
          }
        });
      });
    },

    readClick(id, type) {
      this.$router.push({
        name: 'editServiceType',
        query: { id: id, type: type },
      });
    },

    // deleteSelection() {
    //   MessageBox.confirm('确认删除?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //   }).then(() => {
    //     let params = [];
    //     this.multipleSelection.map((item) => {
    //       params.push(item.id);
    //     });
    //     delFeedBack({ ids: params.join(',') }).then((res) => {
    //       if (res.code == 0) {
    //         this.$message.success('删除成功!');
    //         this.refresh();
    //       }
    //     });
    //   });
    // },
    refresh() {
      this.getServiceTypeData();
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.feedback-container {
  display: flex;
  //   flex-direction: column;
  justify-content: space-between;
  //   width: 100%;
  //   height: 100%;
  gap: 0 32px;
  margin: 20px;
  background: #fff;
  box-shadow: 0 0 6px 1px #acacac;
  .select-tree {
    width: 16%;
    height: 100%;
    padding: 24px;
    .custom-tree-node {
      width: 100%;
      align-items: center;
      padding: 10px;
      display: flex;
      justify-content: space-between;
    }

    /*  鼠标hover改变背景颜色 */
    .el-tree /deep/ .el-tree-node .el-tree-node__content:hover {
      background-color: #f0f7ff !important;
      color: #409eff;
    }
    /*  颜色高亮 */
    /deep/
      .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      color: #409eff;
    }
    /deep/ .el-tree-node__content {
      height: 38px;
    }
  }

  .content {
    flex: 1;
    min-height: 0;
    border-left: 1px solid #f1f1f1;
    padding: 20px;

    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.feedback-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
